module.exports = __webpack_public_path__ + "static/img/22.ce334d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/22.png
// module id = sBCW
// module chunks = 1